<template>
    <div>
        <ul class="list">
            <li>
                <router-link :to="{ name: 'shop', params: { category: null } }">
                    <i class="fa fa-home mr-1"></i> Alle producten
                </router-link>
            </li>
            <li v-for="category in categories" :key="category.id">
                <router-link
                    :to="{ name: 'shop', params: { category: category.slug } }"
                >{{ category.title }}</router-link>

                <!-- Children -->
                <ul v-if="category.descendants.length > 0">
                    <li v-for="child in category.descendants" :key="child.id">
                        <router-link
                            :to="{ name: 'shop', params: { category: child.slug } }"
                        >{{ child.title }}</router-link>

                        <!-- Children -->
                        <ul v-if="child.descendants.length > 0">
                            <li v-for="subchild in child.descendants" :key="subchild.id">
                                <router-link
                                    :to="{ name: 'shop', params: { category: subchild.slug } }"
                                >{{ subchild.title }}</router-link>
                            </li>
                        </ul>
                        <!-- End Children -->
                    </li>
                </ul>
                <!-- End Children -->
            </li>
        </ul>

        <!-- Custom product -->
		<div class="panel">
            <h3 class="mb-2">Niet gevonden?</h3>
            <p>Staat het product dat je wil bestellen niet in het overzicht? Via onderstaande knop kan een een vrij product opgeven.</p>

            <div class="d-flex mt-4">
                <router-link :to="{ name: 'custom-product' }" class="btn">Toevoegen</router-link>
            </div>
        </div>
		<!-- End Custom product -->

		<!-- Transport request -->
		<div class="panel panel--dark">
            <h3 class="mb-2">Transport</h3>
            <p>Dien een transportaanvraag in.</p>

            <div class="d-flex mt-4">
                <router-link :to="{ name: 'transport-request' }" class="btn">Aanvraag indienen</router-link>
            </div>
        </div>
		<!-- End Transport request -->
    </div>
</template>

<script>
export default {
    computed: {
        categories() {
            return this.$store.getters.categories;
        }
    }
};
</script>

<style lang="scss" scoped>
.list {
    padding: 0;
    margin: 0 0 30px 0;
    background-color: $white;

    li {
        list-style-type: none;
        border-bottom: 2px solid $subtle;

        a {
            display: block;
            color: $body;
            padding: 15px 20px;
            font-size: $text-sm;
            background-color: transparent;
            transition: all 0.15s ease-in-out;

            &:hover {
                background-color: $subtle-darker;
                text-decoration: none;
            }

            &.router-link-exact-active {
                background-color: $subtle-darker;
                // padding-left: 15px;
                // border-left: 5px solid $primary;
                font-weight: bold;
                color: $dark;
            }
        }

        &:last-of-type {
            border-bottom: none;
        }
    }

    ul {
        padding-left: 0;
        border-top: 2px solid $subtle;

        li {
            a {
                padding: 15px 20px 15px 30px;
            }
        }

        ul {
            li {
                a {
                    padding: 15px 20px 15px 40px;
                }
            }
        }
    }
}

.panel {
    color: $white;
    font-weight: bold;
    font-size: 1.4rem;
    background-color: $primary;

    h3 {
        color: $white;
    }

    p {
        font-size: $text-sm;
    }

    .btn {
        background-color: $white;
        color: $primary;
    }

	&.panel--dark {
		background-color: $dark;
	}
}
</style>



